import React from "react";
import { Lightbulb } from "lucide-react";

const ZipPayslipNoMatchingTip: React.FC = () => (
  <div
    role="status"
    style={{
      display: "flex",
      gap: 10,
      padding: "12px 14px",
      background: "#e9fdf2",
      border: "1px solid #a7f8ce",
      borderRadius: 12,
      alignItems: "flex-start",
    }}
  >
    <div style={{ color: "#009b48", paddingTop: 1, flexShrink: 0 }}>
      <Lightbulb size={16} />
    </div>
    <div style={{ fontSize: 13, lineHeight: "18px", color: "#384d5c" }}>
      <strong style={{ color: "#062133" }}>No matching criteria needed.</strong>{" "}
      Each PDF in the archive is treated as one employee&apos;s payslip. We&apos;ll
      match them by filename in the background after upload. Use the convention{" "}
      <code
        style={{
          fontFamily: "ui-monospace, Menlo, Consolas, monospace",
          fontSize: "0.9em",
          background: "#f3f3f3",
          padding: "2px 6px",
          borderRadius: 4,
        }}
      >
        YYYYMMDD_EMPLOYEENUMBER.pdf
      </code>{" "}
      (e.g.{" "}
      <code
        style={{
          fontFamily: "ui-monospace, Menlo, Consolas, monospace",
          fontSize: "0.9em",
          background: "#f3f3f3",
          padding: "2px 6px",
          borderRadius: 4,
        }}
      >
        20260520_9001245678901.pdf
      </code>
      ).
    </div>
  </div>
);

export default ZipPayslipNoMatchingTip;
